module.exports = {
  sm: 640,
  md: 743,
  lg: 1024,
  xl: 1280,
  xxl: 1366,
}
